// extracted by mini-css-extract-plugin
export default {"content":"InstagramFeed_content__Y-7ue","InstagramFeed":"InstagramFeed_InstagramFeed__JB5FD","IgOdkaz":"InstagramFeed_IgOdkaz__-p6zK"};